import { computed, makeObservable } from 'mobx'

import { Model } from 'modules/core/lib/mobx-rest'

import competencies from 'modules/competencies/store/collections/competencies'
import competencyOptions from 'modules/competencies/store/collections/competencyOptions'
import type { Competency } from 'modules/competencies/store/models/Competency'
import type { CompetencyOption } from 'modules/competencies/store/models/CompetencyOption'

interface IAssessment {
  [key: string]: any
}

export class Assessment extends Model<IAssessment> {
  static urlRoot() {
    return '/competencies/assessments'
  }

  constructor(data: IAssessment) {
    super(data)

    makeObservable(this, {
      competency: computed,
      option: computed,
      isAssessed: computed,
    })
  }

  get competency(): Competency {
    const competency = competencies.get(this.attributes.competency_id)

    if (!competency) {
      const competencyId = this.attributes.competency_id
      const id = this.attributes.id
      throw new Error(`Competency with id ${competencyId} in assessment with id ${id} not found`)
    }

    return competency
  }

  get option(): CompetencyOption | undefined {
    return competencyOptions.get(this.attributes.competency_option_id)
  }

  get isAssessed(): boolean {
    return !!this.option
  }
}
